<template>
    <v-list nav dense>
        <v-subheader class="pl-0">
            <v-hover v-slot:default="{ hover }">
                <v-btn small text color="grey darken-1" class="text-caption" @click="$emit('update:expanded', !expanded)">
                    INSTANCE SETTINGS
                    <v-icon v-if="hover" right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-hover>
        </v-subheader>
        <v-expand-transition>
            <div v-show="expanded">
                <InstanceMenu :collapsed="collapsed" />
                <v-list-item
                    v-if="isConfigInstanceSelected"
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    active-class="primary--text"
                    :to="{ name: 'config-instance-general', params: { oid: currentOrgOid, sid: activeOrgSpaceId, iid: activeOrgInstanceId } }">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-cog-outline</v-icon>
                            </template>
                            <span>General</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>General</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    v-if="isConfigInstanceSelected && isSpaceAdmin"
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    active-class="primary--text"
                    :to="{ name: 'config-instance-users', params: { oid: currentOrgOid, sid: activeOrgSpaceId, iid: activeOrgInstanceId } }">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-account-group-outline</v-icon>
                            </template>
                            <span>Users</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Users</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="!collapsed" class="my-0">
                        <InstanceInviteDialog ref="drawerInstanceInviteDialog" :instanceName="currentInstanceName || ''">
                            <template v-slot:activator>
                                <v-btn text small class="px-2" min-width="0" @click.stop.prevent="openInstanceInviteFromDrawer">
                                    <v-icon small>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                        </InstanceInviteDialog>
                    </v-list-item-action>
                </v-list-item>
            </div>
        </v-expand-transition>
    </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

const InstanceMenu = () => import('@/components/InstanceMenu.vue')
const InstanceInviteDialog = () => import('@/modules/instance/components/InstanceInviteDialog.vue')

export default {
    name: 'DrawerInstanceSettingsSection',
    components: {
        InstanceInviteDialog,
        InstanceMenu
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState(['userOrgs', 'currentOrgData']),
        ...mapGetters('spaceStore', ['isSpaceAdmin']),
        ...mapGetters('instanceStore', ['currentInstanceName']),
        currentOrgOid() {
            return this.$route.params.oid || this.currentOrgData?.oid || this.userOrgs[0]?.oid
        },
        activeOrgSpaceId() {
            return this.$route.params.sid
        },
        activeOrgInstanceId() {
            return this.$route.params.iid
        },
        isConfigInstanceSelected() {
            return Boolean(this.$route.params.iid)
        }
    },
    methods: {
        openInstanceInviteFromDrawer() {
            this.$refs.drawerInstanceInviteDialog?.openDialog()
        }
    }
}
</script>
